import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APICandidateDetails {

    getUrlDomain(nome_metodo) {

        let result = "";

        if (location.hostname == "localhost") {
            result = location.protocol + "//emtool.local/";
        }

        if (location.hostname != "localhost") {

            result = "https://companysupport.eu/";

        }

        return result + nome_metodo;


    }

    async initFilter(user) {

        let formData = new FormData();

        formData.append("username", user);

        return axios.post(this.getUrlDomain("TwoRecruitCandidateInitFiltersApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async initEditCandidato(id, user) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("id", id);

        return axios.post(this.getUrlDomain("TwoRecruitCandidateInitEditApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

}

export default new APICandidateDetails({
    url: "https://services.ebadge.it/public/api/"
})
